var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarketFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.24759 14C3.16199 14 3.07479 13.9799 2.99319 13.9379C2.73399 13.8049 2.59639 13.4899 2.66519 13.1854L3.82199 8.09386H1.5892C1.3652 8.09386 1.1596 7.95737 1.05641 7.7395C0.953206 7.52163 0.970006 7.25913 1.0996 7.05876L5.48597 0.277639C5.64597 0.0308935 5.93797 -0.0644795 6.19317 0.0448934C6.44997 0.154266 6.60597 0.440386 6.57077 0.738755L6.07077 5.03142H8.38915C8.61555 5.03142 8.82275 5.17055 8.92435 5.39104C9.02675 5.61154 9.00675 5.87666 8.87315 6.07615L3.73159 13.7323C3.61559 13.9055 3.43399 14 3.24759 14Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketFilled);
export default __webpack_public_path__ + "static/media/market-filled.d39a08eb34760c819ea151a328631783.svg";
export { ForwardRef as ReactComponent };